import { CommandBar, DefaultButton, DetailsListLayoutMode, ICommandBarItemProps } from "@fluentui/react";
import { SpinnerTable } from "../../../../components/spinner/spinnerTable";
import { EquipoInfo } from "./componentes/EquipoInfo";
import { HistoricoEquipoTabla } from "./componentes/HistoricoEquipoTabla";
import { UseDetalleEquipo } from "./useDetalleEquipo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PanelFiltroDetalleEquipo } from "./PanelFiltroDetalleEquipo/PanelFiltroDetalleEquipo";
import IconHelper from "../../../../utils/helpers/iconHelper";
import themeBase from "../../../../utils/theme/themeBase";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { useState } from "react";

export interface IDetalleEquipo {
  equipoId: string;
}

interface ILocationState {
  equipoId: string;
}
export const DetalleEquipo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as ILocationState;

  const { items, loading, pagination, getDetalle, handleResetUpdate, onChangeTake, _onkeyUpSearchTable, filter2, resetFilter2, buscar, onChangeComboFilter } = UseDetalleEquipo({ equipoId: state.equipoId })
  const [openPanelFIltrar, setOpenPanelFiltrar] = useState(false)
  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        handleResetUpdate()
        getDetalle()
      },
    }
  ];
  const buttonRight: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_BS_FILTER,
      text: "Buscar",
      onClick: () => {
        setOpenPanelFiltrar(true)
      },
    },
    {
      ...IconHelper.ICON_BACK,
      text: "Atrás",
      onClick: () => {
        navigate(-1);
      },
    }
  ];

  return (
    <>
      <CabeceraTable
        Titulo={"Reporte Equipos"}
        SubTitulo={"Gestión de Reporte de Equipos"}
        onKeyUp={_onkeyUpSearchTable}
      />

      {loading ? (
        <SpinnerTable />
      ) : (
        <>
          {items != null && (
            <>
              <PanelFiltroDetalleEquipo
                filter2={filter2}
                isOpen={openPanelFIltrar}
                onChangeComboFilter={onChangeComboFilter}
                resetFilter2={resetFilter2}
                buscar={buscar}
                onDismiss={() => setOpenPanelFiltrar(false)}
                equipoId={state.equipoId}
              />
              <div style={{ marginBottom: "20px" }}>
                {(buttonLeft.length > 0 || buttonRight.length > 0) && (
                  <div className="ms-Grid-col ms-sm12 ms-lg12">
                    <CommandBar
                      items={buttonLeft}
                      farItems={buttonRight}
                      styles={themeBase.commadStyles}
                    />
                  </div>
                )}
              </div>
              <EquipoInfo
                equipo={items.equipo}
              />
              <br />
              <HistoricoEquipoTabla
                items={items.items}
                loading={loading}
                onChangeTake={onChangeTake}
                pagination={pagination}
              />
            </>
          )}
        </>
      )}
    </>

  );
}